import axios from "axios";

export const INITIATE_REFUND = async (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}transactions/${data.id}/request-refund`)
    .then((res) => {
      return res.data;
    });
};